import { createSlice } from "@reduxjs/toolkit";
import { productListDropdownAPI } from "../../services/productListDropdown";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const productListDropdownSlice = createSlice({
  name: "productListDropdown",
  initialState: data,
  reducers: {
    productListDropdownInfo(state) {
      state.isLoading = true;
    },
    productListDropdownSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    productListDropdownFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    productListDropdownReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const productListDropdownHandler = (data) => async (dispatch) => {
  try {
    dispatch(productListDropdownAction.productListDropdownInfo());
    const response = await productListDropdownAPI(data);
    dispatch(productListDropdownAction.productListDropdownSuccess(response));
  } catch (e) {
    dispatch(productListDropdownAction.productListDropdownFailure(e?.response?.data?.message));
  }
};
export default productListDropdownSlice.reducer;
export const productListDropdownAction = productListDropdownSlice.actions;
